import moment from 'moment'

export const dateFormat = date => {
  return moment(date).format('DD/MM/YY')
}

export const dateFormatTimestamp = date => {
  return dateFormat(moment(date).add(1, 'hours'))
}

export const timeFormat = time => {
  return moment(time, 'HH:mm:ss').format('HH:mm')
}

export const calendar = (date, uppercaseFirstLetter) => {
  let string = moment(date).calendar()
  // string = string.split(' a las')[0]
  string = string.replace('el ', '')

  if (uppercaseFirstLetter) {
    string = string.charAt(0).toUpperCase() + string.slice(1)
  }

  return string
}

export const calendarTimestamp = (date, uppercaseFirstLetter) => {
  return calendar(moment(date).add(1, 'hours'), uppercaseFirstLetter)
}

export const productIcon = iconName => {
  const uri = process.env.REACT_APP_API_BASE_URL;
  return `${uri}/img/products/${iconName}.png`
}

export const containerIcon = iconName => {
  const uri = process.env.REACT_APP_API_BASE_URL;
  return `${uri}/img/containers/${iconName}.png`
}

export const getColorByIndex = i => {
  const colorList = ['#c60021', '#c60073', '#00abc6', '#d1cd00', '#d15700', '#6bd100', '#4c00d1']

  while (i > colorList.length - 1) {
    i = i - colorList.length
  }

  return colorList[i]
}

export const old_getLightColorByIndex = i => {
  const colorList = ['#ffced6', '#ffb7e1', '#c4f7ff', '#fffdad', '#ffdbc1', '#e2ffc4', '#deccff']

  while (i > colorList.length - 1) {
    i = i - colorList.length
  }

  return colorList[i]
}

export const getLightColorByIndex = getColorByIndex



// WEBPACK FOOTER //
// ./src/helpers.js